import BlockListOverview from "@/modules/blockList/views/BlockListView.vue";

export const BlockListRoutes = [
    {
        path: '/prefix/blocked',
        component: BlockListOverview,
    }
]